import { render, staticRenderFns } from "./DeptUserInfo.vue?vue&type=template&id=4a8d6126&scoped=true"
import script from "./DeptUserInfo.vue?vue&type=script&lang=js"
export * from "./DeptUserInfo.vue?vue&type=script&lang=js"
import style0 from "./DeptUserInfo.vue?vue&type=style&index=0&id=4a8d6126&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8d6126",
  null
  
)

export default component.exports